<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《圣剑之刃》以热门动漫为核心基底，为玩家搭建了一个危机与机遇并存的虚域冒险世界，完美延续原作的热血基调与世界观，让每一位刀剑迷都能沉浸式走进熟悉的奇幻战场。作为卡牌与角色扮演结合的手游，游戏拥有清晰的卡牌类型划分，不同类型卡牌各司其职，共同构成了丰富的战斗与养成体系。</p>
    <!-- <pre> -->
    <div class="content">
      <div class="content-item">
        <h4>【超高颜值立绘 全角色覆盖】</h4>
          高精度建模精细打磨细节，肤质、服饰、气质贴合原作人设。亚丝娜的灵动、桐人的酷帅、莉法的娇俏、诗乃的飒爽全员上线，打破传统卡牌颜值短板，颜值党一键入坑，收藏党狂喜！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【快节奏策略对战 上手就爽】</h4>
          摒弃传统卡牌拖沓玩法，主打短平快激斗对决，简化冗余操作，保留策略博弈核心。对局高效流畅，碎片时间随时开局；一键搭配阵容，剑技连招丝滑爆发，全屏特效炸裂，新手也能轻松玩转，秒享制胜快感！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【超强氛围与体验】</h4>
        场景搭配逼真的音效，营造出紧张刺激的冒险氛围。剧情与战斗深度融合，通关特定副本还能解锁背景的补充剧情，同时可获取各类卡牌奖励，丰富卡牌收藏与阵容搭配选择。让你在战斗的同时，逐步揭开虚域世界的神秘面纱，沉浸式感受拯救世界的冒险旅程，真正实现“战斗有爽感，剧情有深度，卡牌有乐趣”的三重体验。
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【超多福利】</h4>
          登录送角色，最高送ur品质角色，每日登录送十抽，首日直接加码送二十抽
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
